<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Termos e Contratos" />
        <div v-if="!showLoading">
            <div class="md-layout-item md-size-100" v-if="dadosAba.dados">

                <GridTermosContratos v-bind:Data="dadosAba.dados.termos"
                                     v-bind:Header="header"
                                     Name="TermosContrato"
                                     Title="Total"
                                     OrderBy="dataAceite"
                                     v-bind:DetalhesCombo1="dadosAba.dados.contratoAssinado"
                                     v-bind:DetalhesCombo2="dadosAba.dados.ano"
                                     v-bind:DetalhesCombo3="null" v-if="$featureToggle && $featureToggle.INTEGRA_TERMO_GRID" />
            </div>
            <div v-else class="md-message">
                <span>{{dadosAba.mensagem}}</span>
            </div>
        </div>
    </Loading>
</template>

<script>
    import GridTermosContratos from '@/components/GridTermosContratos';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';
    import Termo from '@/services/TermoService.js';

    export default {
        components: {
            GridTermosContratos,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado

            if (!sessionStorage.Aluno)
                this.$router.push('home')
            else {
                let a = JSON.parse(sessionStorage.Aluno);

                //Coloca o perfil de aluno disponível na variável aluno
                if (a.PerfilAluno) {
                    this.aluno = a.PerfilAluno;

                    //Verifica se a aba ja está carregada
                    if (a.TermoContrato) {
                        this.dadosAba = a.TermoContrato;
                    }
                }
                else {
                    this.$router.push('home');
                }
            }

            this.termoService = new Termo(this);

            if (this.$featureToggle.INTEGRA_TERMO_GRID) {
            //Verifica se a aba não está carregada
            if (!this.dadosAba) {
                //Popula os dados da aba
                this.showLoading = true;
                this.termoService.ListarTermos(this.aluno.codigoAluno).then(
                    data => {
                        this.dadosAba = data;
                    },
                    error => {
                        if (error.status != 500)
                            this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                        else
                            this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                    }).finally(() => {
                        this.showLoading = false;
                    });
            }
            }
            else {
                this.$modal.alert(this.$msgFeatureToggle);
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.TermoContrato = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                dadosAba: null,
                showLoading: false,
                header: [
                    {
                        Titulo: "Data/Hora Aceite",
                        Field: "dataAceite",
                        Width: "100px",
                        Tipo: "dataTime"
                    },
                    {
                        Titulo: "Contrato Assinado",
                        Field: "descricaoModelo",
                        Width: "120px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Ano",
                        Field: "ano",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Semestre",
                        Field: "semestre",
                        Width: "80px",
                        Tipo: "numero"
                    },
                    {
                        Titulo: "Nome Contratante",
                        Field: "nomeContratante",
                        Width: "120px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Contrato",
                        Field: "codigoTermoAluno",
                        Width: "80px",
                        Tipo: "button"
                    }
                ]
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-message {
        text-align: center;
    }
</style>
